(() => {
  function initializeMiniReviews(page) {
    const carousel = page.querySelector('[data-mini-reviews]');
    if (!carousel) return;
    const slides = [...carousel.querySelectorAll('[data-mini-review]')];
    const dots = [...carousel.querySelectorAll('[data-mini-review-index]')];
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, visible = false, hovering = false, touchStart = null;
    const canPlay = () => carousel.isConnected && visible && !motion.matches && !document.hidden && !hovering && !carousel.contains(document.activeElement);
    function schedule() {
      clearTimeout(timer);
      if (canPlay()) timer = setTimeout(() => { show((index + 1) % slides.length); }, 6000);
    }
    function show(next) {
      index = next;
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.toggleAttribute('inert', i !== index);
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      schedule();
    }
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } });
    carousel.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; schedule(); } });
    carousel.addEventListener('focusin', schedule);
    carousel.addEventListener('focusout', () => queueMicrotask(schedule));
    carousel.addEventListener('touchstart', event => { const touch = event.touches[0]; touchStart = { x: touch.clientX, y: touch.clientY }; }, { passive: true });
    carousel.addEventListener('touchend', event => {
      if (!touchStart) return;
      const touch = event.changedTouches[0], dx = touch.clientX - touchStart.x, dy = touch.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show((index + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
    }, { passive: true });
    carousel.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .2 });
    observer.observe(carousel);
    const update = () => schedule();
    document.addEventListener('visibilitychange', update);
    motion.addEventListener('change', update);
    const unload = event => {
      if (!event.target.contains(carousel)) return;
      clearTimeout(timer); observer.disconnect();
      document.removeEventListener('visibilitychange', update);
      motion.removeEventListener('change', update);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    show(0);
  }
  function initialize(root) {
    root.querySelectorAll('[data-lt-product]').forEach(page => {
      if (page.dataset.initialized) return;
      page.dataset.initialized = 'true';
      initializeMiniReviews(page);
      const guide = page.querySelector('#lt-size-guide');
      if (guide && typeof HTMLDialogElement !== 'undefined') {
        const dialog = document.createElement('dialog');
        dialog.className = 'lt-size-dialog';
        dialog.setAttribute('aria-labelledby', 'lt-size-title');
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'lt-size-dialog-close';
        closeButton.setAttribute('aria-label', 'Fechar guia de medidas');
        closeButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
        guide.before(dialog);
        dialog.append(closeButton, guide);
        let opener, closeTimer, locks = [];
        const restore = () => {
          clearTimeout(closeTimer);
          dialog.classList.remove('is-closing');
          locks.forEach(({ element, value, priority }) => value ? element.style.setProperty('overflow', value, priority) : element.style.removeProperty('overflow'));
          locks = [];
          opener?.focus({ preventScroll: true });
        };
        const closeGuide = () => {
          if (!dialog.open || dialog.classList.contains('is-closing')) return;
          dialog.classList.add('is-closing');
          closeTimer = setTimeout(() => dialog.close(), matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
        };
        page.querySelectorAll('a[href="#lt-size-guide"]').forEach(link => {
          link.setAttribute('aria-haspopup', 'dialog');
          link.addEventListener('click', event => {
            event.preventDefault();
            if (dialog.open) return;
            opener = link;
            locks = [document.documentElement, document.body, document.querySelector('.content-for-layout')].filter(Boolean).map(element => ({ element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow') }));
            locks.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
            dialog.showModal();
            dialog.scrollTop = 0;
            closeButton.focus({ preventScroll: true });
          });
        });
        closeButton.addEventListener('click', closeGuide);
        guide.querySelector('.lt-size-return')?.replaceChildren(document.createTextNode('Voltar às opções de tamanho'));
        guide.querySelector('.lt-size-return')?.addEventListener('click', event => { event.preventDefault(); closeGuide(); });
        dialog.addEventListener('cancel', event => { event.preventDefault(); closeGuide(); });
        let outsideDown = false;
        const outside = event => {
          const box = dialog.getBoundingClientRect();
          return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
        };
        dialog.addEventListener('pointerdown', event => { outsideDown = outside(event); });
        dialog.addEventListener('click', event => { if (outsideDown && outside(event)) closeGuide(); outsideDown = false; });
        dialog.addEventListener('close', restore);
        if (location.hash === '#lt-size-guide') queueMicrotask(() => page.querySelector('a[href="#lt-size-guide"]')?.click());
      }
      const stage = page.querySelector('.lt-product-stage');
      const initialImage = page.querySelector('[data-gallery-image]');
      const thumbs = [...page.querySelectorAll('[data-gallery-src]')];
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      const track = document.createElement('div');
      track.className = 'lt-gallery-track';
      track.tabIndex = 0;
      track.setAttribute('role', 'region');
      track.setAttribute('aria-roledescription', 'carrossel');
      track.setAttribute('aria-label', 'Fotos do produto. Use as setas para navegar.');
      stage.classList.add('lt-product-stage--carousel');
      stage.replaceChildren(track);
      const prev = document.createElement('button'), next = document.createElement('button');
      [prev, next].forEach((button, i) => {
        button.type = 'button';
        button.className = `lt-gallery-arrow lt-gallery-arrow--${i ? 'next' : 'prev'}`;
        button.dataset.galleryDirection = String(i ? 1 : -1);
        button.setAttribute('aria-label', i ? 'Próxima foto' : 'Foto anterior');
        button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${i ? 'm9 5 7 7-7 7' : 'm15 5-7 7 7 7'}"/></svg>`;
        stage.append(button);
      });
      const counter = document.createElement('span');
      counter.className = 'lt-gallery-counter'; counter.setAttribute('aria-hidden', 'true'); stage.append(counter);
      let active = [], index = 0, lastWidth = 0, scrollFrame = 0, drag = null, lastThumb = null;
      function syncGallery() {
        if (!active.length) return;
        index = Math.max(0, Math.min(active.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === active[index])));
        [...track.children].forEach((photo, i) => {
          photo.toggleAttribute('data-gallery-image', i === index);
          photo.setAttribute('aria-hidden', String(i !== index));
        });
        const selectedThumb = active[index];
        if (selectedThumb !== lastThumb) {
          lastThumb = selectedThumb;
          const rail = selectedThumb.parentElement;
          const bounds = rail.getBoundingClientRect(), photo = selectedThumb.getBoundingClientRect();
          if (photo.left < bounds.left) rail.scrollBy({ left: photo.left - bounds.left - 4, behavior: 'instant' });
          else if (photo.right > bounds.right) rail.scrollBy({ left: photo.right - bounds.right + 4, behavior: 'instant' });
        }
        counter.textContent = `${index + 1} / ${active.length}`;
        prev.disabled = index === 0; next.disabled = index === active.length - 1;
        prev.hidden = next.hidden = counter.hidden = active.length < 2;
      }
      function refreshGallery() {
        if (drag && track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
        drag = null; track.classList.remove('is-dragging');
        active = thumbs;
        index = Math.max(0, active.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
        lastThumb = null;
        track.replaceChildren(...active.map((button, i) => {
          const photo = initialImage?.src === new URL(button.dataset.gallerySrc, location.href).href ? initialImage : new Image();
          photo.src = button.dataset.gallerySrc; photo.alt = button.dataset.galleryAlt;
          photo.width = 1254; photo.height = 1254;
          photo.loading = i === index ? 'eager' : 'lazy'; photo.decoding = 'async'; photo.draggable = false;
          return photo;
        }));
        track.scrollTo({ left: index * track.clientWidth, behavior: 'instant' }); syncGallery();
      }
      function goTo(target, instant = false) {
        track.scrollTo({ left: Math.max(0, Math.min(active.length - 1, target)) * track.clientWidth, behavior: instant || reduced() ? 'instant' : 'smooth' });
      }
      thumbs.forEach(button => button.addEventListener('click', () => goTo(active.indexOf(button))));
      prev.addEventListener('click', () => goTo(index - 1)); next.addEventListener('click', () => goTo(index + 1));
      track.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(() => { scrollFrame = 0; syncGallery(); });
      }, { passive: true });
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); goTo(event.key === 'Home' ? 0 : event.key === 'End' ? active.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      // Touch uses native scrolling and snapping; pointer capture is only needed for mouse dragging.
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id: event.pointerId, x: event.clientX, start: track.scrollLeft, moved: false };
      });
      track.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const delta = event.clientX - drag.x;
        if (!drag.moved && Math.abs(delta) < 6) return;
        if (!drag.moved) { drag.moved = true; track.setPointerCapture(event.pointerId); track.classList.add('is-dragging'); }
        track.scrollLeft = drag.start - delta;
      });
      function endDrag(event) {
        if (!drag || drag.id !== event.pointerId) return;
        const moved = drag.moved, delta = drag.x - event.clientX, startIndex = Math.round(drag.start / (track.clientWidth || 1));
        drag = null; track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        if (event.type === 'pointercancel') { goTo(index); return; }
        if (moved) goTo(Math.abs(delta) > Math.max(35, track.clientWidth * .12) ? startIndex + Math.sign(delta) : startIndex);
      }
      track.addEventListener('pointerup', endDrag); track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', () => { if (drag) { drag = null; track.classList.remove('is-dragging'); goTo(index); } });
      track.addEventListener('pointerleave', event => { if (drag && !drag.moved) endDrag(event); });
      refreshGallery();
      new ResizeObserver(() => {
        if (track.clientWidth && Math.abs(track.clientWidth - lastWidth) > 1) { lastWidth = track.clientWidth; goTo(index, true); }
      }).observe(track);
      const form = page.querySelector('.lt-product-form');
      if (!form) return;
      const quantity = form.querySelector('[name="quantity"]');
      const add = form.querySelector('[name="add"]');
      const status = form.querySelector('[data-product-status]');
      const cartLink = form.querySelector('[data-product-cart-link]');
      const offers = form.querySelector('[data-purchase-offers]');
      const quantityRow = form.querySelector('.lt-product-quantity');
      const offerCount = () => Number(form.querySelector('[name="lt-offer"]:checked')?.value || 1);
      const pricingReady = () => page.dataset.catalogPricesReady === 'true' && (offerCount() === 1 || page.dataset.bundlePricesReady === 'true');
      function updateOfferAvailability() {
        const available = variantInputs.find(input => input.checked)?.dataset.variantAvailable === 'true';
        add.disabled = !available || !pricingReady();
        add.textContent = !available ? 'INDISPONÍVEL' : pricingReady() ? 'ADICIONAR AO CARRINHO' : 'OFERTAS EM PREPARAÇÃO';
      }
      const selectedPanel = () => offers?.querySelector(`[data-offer-panel="${offerCount()}"]`);
      const offerVariant = item => variantInputs.find(variant => variant.dataset.variantColor === item.querySelector('[data-offer-color]:checked')?.value && variant.dataset.variantSize === item.querySelector('[data-offer-size]:checked')?.value && variant.dataset.variantAvailable === 'true');
      const variantInputs = [...form.querySelectorAll('[name="id"]')];
      const colorInputs = [...form.querySelectorAll('[data-product-color]')];
      let currentColor = variantInputs.find(input => input.checked)?.dataset.variantColor || 'Verde';
      function showColor(color) {
        const colorChanged = color !== currentColor;
        const key = color === 'Azul' ? 'blue' : color === 'Rosa' ? 'pink' : 'green';
        page.querySelectorAll('[data-detail-color-image]').forEach(detail => { detail.src = detail.dataset[key]; detail.alt = `${detail.dataset.detailLabel} — ${color}`; });
        currentColor = color;
        variantInputs.forEach(input => {
          const matches = input.dataset.variantColor === color;
          input.closest('[data-size-color]').hidden = !matches;
          input.disabled = !matches || input.dataset.variantAvailable !== 'true';
        });
        colorInputs.forEach(input => { input.checked = input.value === color; });
        const label = form.querySelector('[data-selected-color]');
        if (label) label.textContent = color;
        const target = active.findIndex(button => button.dataset.galleryColor === color);
        if (colorChanged || active[index]?.dataset.galleryColor !== color) {
          if (target >= 0) {
            const photo = track.children[target];
            photo.loading = 'eager';
            goTo(target, true); syncGallery();
            if (!reduced()) {
              photo.getAnimations().forEach(animation => animation.cancel());
              photo.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
            }
          }
        }
        if (target >= 0) {
          const thumb = active[target], rail = thumb.parentElement;
          rail.scrollTo({ left: rail.scrollLeft + thumb.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: 'instant' });
        }
      }
      colorInputs.forEach(input => {
        input.addEventListener('click', () => { if (input.checked) showColor(input.value); });
        input.disabled = !variantInputs.some(variant => variant.dataset.variantColor === input.value && variant.dataset.variantAvailable === 'true');
        input.addEventListener('change', () => {
          if (!input.checked) return;
          const size = variantInputs.find(variant => variant.checked)?.dataset.variantSize;
          const choices = variantInputs.filter(variant => variant.dataset.variantColor === input.value && variant.dataset.variantAvailable === 'true');
          const selected = choices.find(variant => variant.dataset.variantSize === size) || choices[0];
          if (!selected) return;
          showColor(input.value);
          selected.checked = true;
          selected.dispatchEvent(new Event('change'));
        });
      });
      showColor(currentColor);
      variantInputs.forEach(radio => radio.addEventListener('change', () => {
        showColor(radio.dataset.variantColor);
        const url = new URL(location.href); url.searchParams.set('variant', radio.value);
        history.replaceState(history.state, '', url);
        status.textContent = ''; cartLink.hidden = true;
        updateOfferAvailability();

      }));
      function updateOfferItem(item, followGallery = false) {
        const selected = item.closest('[data-offer-panel]').dataset.offerPanel === String(offerCount());
        const colors = [...item.querySelectorAll('[data-offer-color]')];
        const sizes = [...item.querySelectorAll('[data-offer-size]')];
        colors.forEach(input => {
          const available = variantInputs.some(v => v.dataset.variantColor === input.value && v.dataset.variantAvailable === 'true');
          input.disabled = !selected || !available;
          input.closest('label').classList.toggle('is-unavailable', !available);
        });
        let color = colors.find(input => input.checked);
        if (!color || !variantInputs.some(v => v.dataset.variantColor === color.value && v.dataset.variantAvailable === 'true')) {
          color = colors.find(input => variantInputs.some(v => v.dataset.variantColor === input.value && v.dataset.variantAvailable === 'true'));
          if (color) color.checked = true;
        }
        item.querySelector('[data-item-color-name]').textContent = color?.value || '';
        sizes.forEach(input => {
          const available = variantInputs.some(v => v.dataset.variantColor === color?.value && v.dataset.variantSize === input.value && v.dataset.variantAvailable === 'true');
          input.disabled = !selected || !available;
          input.closest('label').classList.toggle('is-unavailable', !available);
        });
        const size = sizes.find(input => input.checked);
        if (selected && (!size || size.disabled)) { const available = sizes.find(input => !input.disabled); if (available) available.checked = true; }
        const variant = offerVariant(item);
        if (followGallery && variant) { variant.checked = true; variant.dispatchEvent(new Event('change')); }
      }
      function selectOffer() {
        const count = offerCount();
        offers.querySelectorAll('[data-offer-panel]').forEach(panel => {
          const selected = Number(panel.dataset.offerPanel) === count;
          panel.hidden = !selected;
          panel.closest('.lt-offer-option').classList.toggle('is-selected', selected);
          panel.querySelectorAll('[data-offer-color],[data-offer-size]').forEach(input => { input.disabled = !selected; });
        });
        quantity.disabled = count !== 1;
        quantityRow.querySelectorAll('button').forEach(button => { button.disabled = count !== 1; });
        status.textContent = ''; cartLink.hidden = true;
        const items = [...selectedPanel().querySelectorAll('[data-offer-item]')];
        items.forEach((item, i) => updateOfferItem(item, i === 0));
        const variant = variantInputs.find(input => input.checked);
        if (count === 1 && variant) variant.dispatchEvent(new Event('change'));
        updateOfferAvailability();
      }
      offers?.querySelectorAll('[name="lt-offer"]').forEach(radio => radio.addEventListener('change', selectOffer));
      offers?.querySelectorAll('[data-offer-item]').forEach(item => {
        item.querySelectorAll('[data-offer-color],[data-offer-size]').forEach(input => input.addEventListener('change', () => updateOfferItem(item, item === selectedPanel().querySelector('[data-offer-item]'))));
        updateOfferItem(item);
      });
      if (offers) selectOffer();
      form.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        quantity.value = String(Math.max(1, Math.min(99, (Number(quantity.value) || 1) + Number(button.dataset.quantityChange))));
      }));
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        if (!pricingReady()) { status.textContent = 'Estamos preparando os novos preços. A compra será liberada quando os valores estiverem confirmados no checkout.'; return; }
        busy = true;
        add.disabled = true;
        add.textContent = 'ADICIONANDO…';
        status.textContent = '';
        cartLink.hidden = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const count = offerCount();
          let request = { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) };
          if (count > 1) {
            const variants = [...selectedPanel().querySelectorAll('[data-offer-item]')].map(offerVariant);
            if (variants.some(variant => !variant)) throw new Error('Escolha uma cor e um tamanho disponíveis para cada macacão.');
            const quantities = new Map();
            variants.forEach(variant => { const id = Number(variant.value); quantities.set(id, (quantities.get(id) || 0) + 1); });
            request = { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id, quantity })) }) };
          }
          const response = await fetch(root + 'cart/add.js', request);
          if (!response.ok) throw new Error(response.status === 422 ? 'Essa quantidade não está disponível. Confira o tamanho e tente uma quantidade menor.' : 'Não foi possível adicionar agora. Tente novamente.');
          status.textContent = count > 1 ? `Seus ${count} macacões foram adicionados ao carrinho.` : 'Seu macacão foi adicionado ao carrinho.';
          cartLink.hidden = false;
          try {
            const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
            if (!cartResponse.ok) window.LittleTurtleCart?.open({ opener: add });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              window.LittleTurtleCart?.open({ cart, opener: add });
              if (count > 1) status.textContent = `Seus ${count} macacões foram adicionados. Confira os valores no carrinho.`;
              document.querySelectorAll('.lt-cart').forEach(link => {
                let count = link.querySelector('span');
                if (!count) { count = document.createElement('span'); link.append(count); }
                count.textContent = String(cart.item_count);
                link.setAttribute('aria-label', `Carrinho, ${cart.item_count} itens`);
              });
            }
          } catch { /* The item was added; a badge refresh must not report a failed purchase. */
            window.LittleTurtleCart?.open({ opener: add });
          }
        } catch (error) {
          status.textContent = error.message === 'Failed to fetch' ? 'Confira sua conexão e tente novamente.' : error.message;
        } finally {
          busy = false;
          updateOfferAvailability();
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
